import { render, staticRenderFns } from "./KbFolderPage.vue?vue&type=template&id=3697add3&scoped=true"
import script from "./KbFolderPage.vue?vue&type=script&lang=js"
export * from "./KbFolderPage.vue?vue&type=script&lang=js"
import style0 from "./KbFolderPage.vue?vue&type=style&index=0&id=3697add3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3697add3",
  null
  
)

export default component.exports